export interface CodeToken {
  text: string;
  kind: 'text' | 'string' | 'number' | 'keyword' | 'comment';
}
const grammars: Readonly<Record<string, 'json' | 'script' | 'python' | 'shell'>> = {
  json: 'json',
  js: 'script',
  javascript: 'script',
  ts: 'script',
  typescript: 'script',
  py: 'python',
  python: 'python',
  sh: 'shell',
  bash: 'shell',
  shell: 'shell',
};
const keywords = new Set(
  'const let var function return async await if else for while new true false null undefined import from export interface type class throw try catch def print None True False in and or not return echo then fi do done'.split(
    ' ',
  ),
);

/** Tokenization never emits HTML. Unknown languages remain plain code, without guessing. */
export function tokenizeMessageCode(text: string, language: string): CodeToken[] {
  const grammar = Object.hasOwn(grammars, language.toLowerCase())
    ? grammars[language.toLowerCase()]
    : undefined;
  if (!grammar) return [{ kind: 'text', text }];
  const pattern =
    /("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\x60(?:\\.|[^\x60\\])*\x60|\/\/[^\n]*|\/\*[\s\S]*?\*\/|#[^\n]*|\b\d+(?:\.\d+)?\b|\b[A-Za-z_$][\w$]*\b)/gu;
  const result: CodeToken[] = [];
  let end = 0;
  for (const match of text.matchAll(pattern)) {
    const at = match.index;
    if (at > end) result.push({ kind: 'text', text: text.slice(end, at) });
    const token = match[0];
    const quote = token[0] === '"' || (grammar !== 'json' && (token[0] === "'" || token[0] === '\x60'));
    const comment =
      grammar === 'script'
        ? token.startsWith('//') || token.startsWith('/*')
        : grammar === 'python' || grammar === 'shell'
          ? token.startsWith('#')
          : false;
    const kind = quote
      ? 'string'
      : comment
        ? 'comment'
        : /^\d/u.test(token)
          ? 'number'
          : keywords.has(token)
            ? 'keyword'
            : 'text';
    result.push({ kind, text: token });
    end = at + token.length;
  }
  if (end < text.length) result.push({ kind: 'text', text: text.slice(end) });
  return result;
}

export const MESSAGE_CODE_CLASSES: Record<CodeToken['kind'], string> = {
  text: 'text-fg',
  string: 'text-success-fg',
  number: 'text-warn-fg',
  keyword: 'font-medium text-info-fg',
  comment: 'text-fg-muted',
};
